import { render, staticRenderFns } from "./BoardListArchive.vue?vue&type=template&id=24591956"
import script from "./BoardListArchive.vue?vue&type=script&lang=js"
export * from "./BoardListArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports